import _sortBy from 'lodash.sortby';
import { computed } from '@ember/object';
import { gt } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import { resolve } from 'rsvp';
import { task } from 'ember-concurrency';
import EnvironmentService from './environment';
import RavenService from './raven';
import DS from 'ember-data';
import ApiService from './api';
import { isEmpty } from '@ember/utils';

export default class NotificationsService extends Service {
  @service environment!: EnvironmentService;
  @service raven!: RavenService;
  @service store!: DS.Store;
  @service api!: ApiService;

  all: Record<string, any>[] = [];

  @computed('all.@each.activated')
  get latest() {
    return _sortBy(this.all, ['activated']).reverse();
  }

  @computed('all.@each.viewed')
  get unviewed() {
    return this.all.filter((n) => isEmpty(n.viewed) || n.viewed === false);
  }

  @gt('unviewed.length', 0)
  hasUnviewed!: boolean;

  fetch = task(async () => {
    try {
      this.set('all', await this.store.findAll('notification'));
    } catch (e) {
      this.raven.captureException(e);
    }
  });

  markAllAsViewed() {
    let unviewedIds = this.unviewed.map((n) => n.id);

    if (!unviewedIds.length) {
      return resolve();
    }

    return this.api
      .post('notifications/mark_as_viewed', {
        pathScope: 'account',
        data: { ids: unviewedIds },
      })
      .then(() => this.fetch.perform());
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    notifications: NotificationsService;
  }
}
